import { Component } from '@angular/core';

@Component({
  selector: 'app-predictions',
  imports: [],
  templateUrl: './predictions.html',
  styleUrl: './predictions.scss',
})
export class Predictions {

}
